import Dropdown from '../../../../components/Dropdown'
import {
    FlexBox,
    FlexLeft,
    FlexRight,
    SectionFiltersGrid
} from '../../../../components/UtilsResponsive/UtilsResponsive.style'
import OptionExcel from './Export/OptionExcel'
import Filters from './Filters'

export default function Control() {
    return (
        <SectionFiltersGrid>
            <FlexBox>
                <FlexLeft>
                    <Filters />
                </FlexLeft>
                <FlexRight>
                    <Dropdown label="Exportar" icon="download" clear={false}>
                        <OptionExcel />
                    </Dropdown>
                </FlexRight>
            </FlexBox>
        </SectionFiltersGrid>
    )
}
